const mainUrl2 = process.env.NEXT_PUBLIC_MAIN_URL2
const mainUrl = process.env.NEXT_PUBLIC_MAIN_URL

export const menuItems = [
  { label: 'İş İlanları', url: mainUrl2 + '/is-ilanlari' },
  { label: 'İşin Olsun Hizmet', url: mainUrl2 + '/hizmet' },
  { label: 'Çalışan Arıyorum', url: mainUrl2 + '/isveren' },
  { label: 'Blog', url: mainUrl + '/blog/' },
]